module.exports = __webpack_public_path__ + "static/media/Rockin' Horse Rider.26d4c29f.jpg";